// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'
import { GlobalContext } from 'context/GlobalContextProvider'

// Img
import TailoredImage from 'public/img/services/shop_floor2.webp'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'
import { getFontBody } from '@/assets/theme/fonts'

export default function TailoredSection() {
  const { t } = useTranslation('servicesOtAwarenessTraining')
  const { screenDimensions } = useContext(GlobalContext)

  const stacked = screenDimensions.width < breakpoints.desktopToMobile

  const items = [
    t('tailored.items.01'),
    t('tailored.items.02'),
    t('tailored.items.03'),
    t('tailored.items.04'),
    t('tailored.items.05'),
    t('tailored.items.06'),
    t('tailored.items.07'),
    t('tailored.items.08'),
    t('tailored.items.09'),
    t('tailored.items.10')
  ]

  const getContent = () => (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: stacked ? '1fr' : '1fr 1fr',
        gap: stacked ? '2rem' : '3rem',
        // Stretch, so the photo runs the full height of the text beside it
        // rather than leaving a gap where the two columns differ.
        alignItems: 'stretch',
        width: '100%'
      }}
    >
      <Box>
        <SectionHeader
          eyebrow={t('tailored.eyebrow')}
          title={t('tailored.title')}
          intro={[t('tailored.intro1'), t('tailored.intro2')]}
        />

        <BulletGrid items={items} columns={2} />

        <Typography
          sx={{
            fontSize: getFontBody(),
            lineHeight: 1.7,
            color: themeColors.gray.defaultText,
            marginTop: '2rem'
          }}
        >
          {t('tailored.note')}
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'relative',
          borderRadius: '10px',
          overflow: 'hidden',
          minHeight: stacked ? '16rem' : '100%',
          order: stacked ? -1 : 0
        }}
      >
        <Image
          src={TailoredImage}
          alt=""
          fill
          sizes="(max-width: 990px) 100vw, 48vw"
          style={{ objectFit: 'cover', objectPosition: 'center' }}
        />
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
